import { highlightCurrentPage } from "./_navigation";
import { homeHero } from "./_homeHero";
import { vimeoPlayback } from "./_vimeoPlayback";
import { bootstrapCollapseToggle } from "./_bootstrapCollapse";
import "bootstrap/js/src/dropdown";
import "bootstrap/js/src/offcanvas";
import AOS from "aos";
// import "aos/dist/aos.css";

window.addEventListener("load", function () {
  function initialize() {
    highlightCurrentPage();
    homeHero();
    vimeoPlayback();
    bootstrapCollapseToggle();
    AOS.init({
      duration: 1000,
    });
  }

  initialize();
});
